<span class="ap-icon-link" data-testid="icon-link-container">
    @if (!newTab()) {
        <a [href]="link()" class="ap-icon-link__wrapper" data-testid="link">
            <asn-icon class="ap-icon-link__icon" [name]="iconName()" [size]="iconSize()" data-testid="icon"></asn-icon>
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </a>
    }
    @if (newTab()) {
        <a [href]="link()" target="_blank" rel="noopener noreferrer" class="ap-icon-link__wrapper" data-testid="link">
            <asn-icon class="ap-icon-link__icon" [name]="iconName()" [size]="iconSize()" data-testid="icon"></asn-icon>
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            <div class="ap-sr-only">Opent in een nieuw tabblad</div>
        </a>
    }
</span>

<ng-template #contentTemplate><ng-content></ng-content></ng-template>
